module.exports = __webpack_public_path__ + "static/media/DECLARACIÓN.720ce9bb.pdf";